/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_ngcontent-%COMP%]:not(.fa){font-family:\"Open Sans\",sans-serif}@media all and (min-width:768px){.gamesViewIframe[_ngcontent-%COMP%]{height:calc(100vh - 100px);padding:0!important}}@media all and (max-width:768px){.gamesViewIframe[_ngcontent-%COMP%]{height:100%;min-height:unset;padding:0!important}.gamesViewIframe[_ngcontent-%COMP%]   iframe[_ngcontent-%COMP%]{margin:0!important}}.gamesViewIframe[_ngcontent-%COMP%]   iframe[_ngcontent-%COMP%]{border:none!important;height:100%!important;margin:0!important}"];
export { styles as styles };
